import { MatterSubItemContextMenu } from "@/components/features/matter/context-menus/MatterSubItemContextMenu";
import type { Matter } from "@/lib/types";
import type { ReactNode } from "react";

interface MatterTreatmentAppointmentContextMenuProps {
  canDelete: boolean;
  dateLabel: string;
  id: string;
  isDeleting: boolean;
  matter: Matter;
  onDelete: () => Promise<void>;
  onEdit: () => void;
  trigger: ReactNode;
  typeLabel?: string;
}

export const MatterTreatmentAppointmentContextMenu = ({
  canDelete,
  dateLabel,
  id,
  isDeleting,
  matter,
  onDelete,
  onEdit,
  trigger,
  typeLabel,
}: MatterTreatmentAppointmentContextMenuProps) => (
  <MatterSubItemContextMenu
    copyValue={[
      `Treatment date: ${dateLabel}`,
      typeLabel ? `Type: ${typeLabel}` : undefined,
    ]
      .filter(Boolean)
      .join("\n")}
    delete={canDelete ? { disabled: isDeleting, onSelect: onDelete } : false}
    entityLabel={dateLabel || "treatment date"}
    entityName="treatment date"
    matter={matter}
    onEdit={onEdit}
    subItem={{ id, type: "medical-treatment-appointment" }}
    trigger={trigger}
  />
);
